import { BriefcaseBusiness, Clock, Users, Wrench } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

interface SummaryCardsProps {
  totalUsers: number;
  totalSkills: number;
  activeGroups: number;
  availableExperts: number;
}

const cards = [
  { key: 'totalUsers', label: 'Total Users', icon: Users },
  { key: 'totalSkills', label: 'Total Skills', icon: Wrench },
  { key: 'activeGroups', label: 'Active Lists', icon: BriefcaseBusiness },
  { key: 'availableExperts', label: 'Available Experts', icon: Clock },
] as const;

export default function SummaryCards({ totalUsers, totalSkills, activeGroups, availableExperts }: SummaryCardsProps) {
  const { theme } = useTheme();
  const values = { totalUsers, totalSkills, activeGroups, availableExperts };

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {cards.map(({ key, label, icon: Icon }) => (
        <article key={key} className="rounded-lg border bg-white p-5 shadow-sm" style={{ borderColor: theme.border, backgroundColor: theme.surface }}>
          <div className="flex items-center justify-between gap-4">
            <div>
              <p className="mb-1 text-sm font-medium" style={{ color: theme.textSecondary }}>
                {label}
              </p>
              <p className="mb-0 text-2xl font-bold" style={{ color: theme.text }}>
                {values[key].toLocaleString()}
              </p>
            </div>
            <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-blue-50">
              <Icon className="h-5 w-5" style={{ color: theme.primary }} />
            </div>
          </div>
        </article>
      ))}
    </div>
  );
}
